import classNames from 'classnames';
import { ReactNode } from 'react';

import { CheckBigIcon, CircleIcon } from '@/components';
interface Props {
  icon?: ReactNode;
  name: string;
  id: string;
  checked: boolean;
  onClick: (item: { name: string; id: string }) => void;
  className?: string;
  disabled?: boolean;
}
export function CheckItem(props: Props) {
  const { icon, checked, name, id, onClick, className, disabled } = props;
  return (
    <div
      className={classNames(
        'p-4 mb-3 border border-gray-200 rounded-md flex flex-row justify-between items-center',
        className,
        {
          'border-primary-600': checked,
          'bg-primary-50': checked,
          'bg-gray-100': disabled,
          'border-gray-100': checked
        }
      )}
      onClick={() => {
        !disabled && onClick({ name, id });
      }}
    >
      <div className="flex flex-row justify-start items-center cursor-pointer gap-2">
        {checked ? <CheckBigIcon /> : <CircleIcon />}
        <div className="flex items-center gap-3">
          {icon}
          <div className="flex flex-col">
            <span
              className={classNames('text-md font-medium text-gray-900  flex-1 truncate', {
                'text-gray-500': checked
              })}
              title={name}
            >
              {name}
            </span>
            <span className={classNames('text-md font-medium text-gray-700 flex-1 truncate')} title={id}>
              {id}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
